import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import logoonlinepaathshala from '../images/logo2.png';
export default function Mainmenu() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <>
      <nav className="bg-white container mx-auto">
        <div className="flex flex-wrap items-center justify-between mr-0 px-3 pt-2">
          <Link to="/" className="flex items-center space-x-3 rtl:space-x-reverse">
            <div className='flex items-center justify-center flex-col'>
              <img src={logoonlinepaathshala} className="h-14" alt="online paathshala" />
              <div className='flex justify-center gap-1'>
                <div>
                  <span className='text-cuscolor-light font-bold'>Online</span>
                </div>
                <div>
                  <span className='text-cuscolor font-bold'>पाठशाला</span>
                </div>
              </div>
            </div>
          </Link>

          <button
            onClick={toggleMenu}
            type="button"
            className="inline-flex items-center p-2 w-10 h-10 justify-center text-sm text-cuscolor-light rounded-lg md:hidden    "
            aria-controls="navbar-default"
            aria-expanded={isMenuOpen}
          >
            <span className="sr-only">Open main menu</span>
            <svg
              className="w-5 h-5"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 17 14"
            >
              <path
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M1 1h15M1 7h15M1 13h15"
              />
            </svg>
          </button>

          <div className={`${isMenuOpen ? '' : 'hidden'} w-full md:block md:w-auto`} >
            <ul className="font-medium flex flex-col bg-cuscolor md:bg-cuscolor-dark p-4 md:p-0 mt-4 border rounded-lg md:flex-row md:space-x-8 rtl:space-x-reverse md:mt-0 md:border-0 md:bg-white">
              <li>
                <Link to="/" className="block py-2 px-3 text-white  md:text-cuscolor-light  md:hover:text-cuscolor rounded md:bg-transparent font-extrabold  md:p-0">Home</Link>
              </li>
              <li>
                <Link to="/online-neb-samplepappers" className="block py-2 px-3 text-white  md:text-cuscolor-light  rounded md:hover:text-cuscolor md:border-0 font-extrabold  md:p-0">Sample Paper</Link>
              </li>
              <li>
                <Link to="/online-courses" className="block py-2 px-3 text-white  md:text-cuscolor-light rounded  md:hover:text-cuscolor md:border-0 font-extrabold   md:p-0 ">Courses</Link>
              </li>
              <li>
                <Link to="/e-notes" className="block py-2 px-3 text-white  md:text-cuscolor-light rounded  md:hover:text-cuscolor md:border-0 font-extrabold  md:p-0 ">Notes</Link>
              </li>
             
              <li>
                <Link to="/contact" className="block py-2 px-3 text-white  md:text-cuscolor-light  rounded md:hover:text-cuscolor  md:border-0 font-extrabold  md:p-0">About</Link>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </>
  );
}
